import { Edit } from "@mui/icons-material";
import { GRID_CHECKBOX_SELECTION_COL_DEF } from "@mui/x-data-grid";
import { format, parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";

import Colors from "../../../../../components/global/Colors";
import Navigation from "../../../../../components/navigations/finance/cases/detail/navigation";
import BasicButton from "../../../../../components/ui library/components/buttons/BasicButton";
import CustomDataGrid from "../../../../../components/ui library/components/data-grid/CustomDataGrid";
import Pagination from "../../../../../components/ui library/components/data-grid/Pagination";
import {
  sortDates,
  sortNumbers,
  sortStrings,
} from "../../../../../components/ui library/helpers/functions";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { useQueryParams } from "../../../../../hooks/useQueryParams";

import AddPayment from "./components/AddPayment";
import DeletePayment from "./components/DeletePayment";

export default () => {
  const { _case } = useParentLoaderData();
  const { filters, updateFilter } = useQueryParams();
  const { settlementCheck, settlementCheckOptions, entityOpts, count } = useLoaderData();
  const [selectedRows, setSelectedRows] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [itemToEdit, setItemToEdit] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const columns = [
    {
      ...GRID_CHECKBOX_SELECTION_COL_DEF,
      renderHeader: () => <></>,
    },
    {
      field: "checkType",
      headerName: "Type",
      flex: 1,
      align: "center",
      headerAlign: "center",
      valueFormatter: getCheckTypeName,
      sortable: false,
      filterable: false,
      sortComparator: (val1, val2) => sortStrings(getCheckTypeName(val1), getCheckTypeName(val2)),
    },
    {
      field: "paidBy",
      headerName: "From",
      flex: 2,
      align: "center",
      headerAlign: "center",
      valueFormatter: (value) => value.name ?? "",
      sortable: false,
      filterable: false,
      sortComparator: (val1, val2) => sortStrings(val1.name, val2.name),
    },
    {
      field: "paidTo",
      headerName: "To",
      flex: 2,
      align: "center",
      headerAlign: "center",
      valueFormatter: (value) => value.name ?? "",
      sortable: false,
      filterable: false,
      sortComparator: (val1, val2) => sortStrings(val1.name, val2.name),
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      valueFormatter: (value) => `$${value}`,
      align: "right",
      headerAlign: "right",
      sortable: false,
      filterable: false,
      sortComparator: sortNumbers,
    },
    {
      field: "checkDate",
      headerName: "Date",
      flex: 1,
      valueFormatter: (value) => format(parseISO(value), "MM/dd/yyyy"),
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      sortComparator: sortDates,
    },
    {
      field: "actions",
      headerName: "",
      align: "right",
      flex: 0.5,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <Edit onClick={() => handleOpenEdit(params.row)} />;
      },
    },
  ];

  function getCheckTypeName(value) {
    return (
      settlementCheckOptions?.checkTypeOptions?.find((opt) => opt?.value === value)?.display_name ??
      ""
    );
  }

  const handleOpenEdit = (payment) => {
    setAddModalOpen(true);
    setItemToEdit(payment);
  };

  const handleOpenDelete = () => {
    const item = settlementCheck.find((payment) => payment.id === selectedRows[0]);
    setItemToDelete(item);
    setDeleteModalOpen(true);
  };

  useEffect(() => {
    updateFilter("limit", filters.get("limit") || 25);
  }, []);

  return (
    <Navigation activeTab="payments" _case={_case}>
      <div className="p-4">
        <div className="mb-1 flex items-center justify-end">
          {selectedRows.length > 0 && (
            <BasicButton
              className="mr-4"
              color="error"
              disabled={selectedRows.length === 0}
              onClick={handleOpenDelete}
              text="Delete"
              sx={{
                backgroundColor: Colors.red[500],
              }}
            />
          )}
          <BasicButton
            onClick={() => setAddModalOpen(true)}
            text="Add Payment"
            variant="outlined"
          />
        </div>
        <div className="h-[calc(100vh-18rem)] w-full overflow-y-auto">
          <CustomDataGrid
            columns={columns}
            checkboxSelection
            disableRowSelectionOnClick
            disableMultipleRowSelection
            rowSelection
            rows={settlementCheck ?? []}
            onRowSelectionModelChange={(val) => setSelectedRows(val)}
          />
        </div>
        <Pagination filters={filters} updateFilter={updateFilter} totalCount={count} />
        <AddPayment
          open={addModalOpen}
          setOpen={setAddModalOpen}
          checkTypeOptions={settlementCheckOptions.checkTypeOptions}
          entityOpts={entityOpts}
          caseDetail={_case}
          activeItem={itemToEdit}
          setActiveItem={setItemToEdit}
        />
        <DeletePayment
          activeItem={itemToDelete}
          checkTypeOptions={settlementCheckOptions.checkTypeOptions}
          open={deleteModalOpen}
          setActiveItem={setItemToDelete}
          setOpen={setDeleteModalOpen}
        />
      </div>
    </Navigation>
  );
};
